export default "__VITE_ASSET__912a795c__"